import { FC, useEffect } from "react";
import { Row, Col, Input, message, Card, Form, Modal, Button } from "antd";
import { t, CoreResource } from "shared/plugins/localization";
import {
  DefaultErrorMessage,
  NotificationText,
  Save,
  Successfully,
  UpdateDataSuccessfully,
  WebsiteConfigText,
} from "shared/constants/define-localization";
import { WebsiteConfigModel } from "states/website-config/website-config.models";
import {
  getWebsiteConfig,
  updateWebsiteConfig,
} from "states/website-config/website-config.api";
import { Store } from "antd/lib/form/interface";
import { SaveOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { setLoading } from "states/global-value/global-value.slice";

interface IWebsiteConfigProps {}
const { TextArea } = Input;

const WebsiteConfig: FC<IWebsiteConfigProps> = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const getConfig = async () => {
    try {
      const res = await getWebsiteConfig();
      form.setFieldsValue(res.data);
    } catch (error) {
      message.error(
        error?.response?.data?.error?.message ??
          "Lỗi hệ thống"
      );
    }
  };

  const onFinish = async (values: Store) => {
    dispatch(setLoading(true));
    try {
      let payload = {
        privateGoogleCaptcha: values?.privateGoogleCaptcha,
        publicGoogleCaptcha: values?.publicGoogleCaptcha,
        customCodeBeginBodyTag: values?.customCodeBeginBodyTag,
        customCodeInHeadTag: values?.customCodeInHeadTag,
        customCodeEndBodyTag: values?.customCodeEndBodyTag,
        robotTxt:values?.robotTxt,
        googleAuthClientId:values?.googleAuthClientId,
        googleAuthClientSecret: values?.googleAuthClientSecret,
        googleAuthRedirectUrl: values?.googleAuthRedirectUrl,
        facebookAuthClientId:values?.facebookAuthClientId,
        facebookAuthClientSecret: values?.facebookAuthClientSecret,
        facebookAuthRedirectUrl: values?.facebookAuthRedirectUrl
      } as WebsiteConfigModel;
      await updateWebsiteConfig(payload);
      dispatch(setLoading(false));
      Modal.success({
        title: "Thành công",
        content: "Cập nhật thành công",
      });
    } catch (error) {
      dispatch(setLoading(false));
      Modal.error({
        title: "Thông báo",
        content:
          error?.response?.data?.error?.message ??
          "Lỗi hệ thống",
      });
    }
  };
  const onSaved = () => {
    form.submit();
  };
  useEffect(() => {
    getConfig();
  }, []);

  return (
    <div className="website-config">
      <Row gutter={[16, 16]} className="mb-4">
        <Col flex="auto"></Col>
        <Col flex="auto" className="d-flex justify-content-end">
          <Button onClick={onSaved} type="primary" icon={<SaveOutlined />}>
            {"Lưu"}
          </Button>
        </Col>
      </Row>
      <Row gutter={[16, 16]} justify="space-between">
        <Col span={24}>
          <Card title="Website settings" bordered={false}>
            <Form
              form={form}
              name="website-config"
              onFinish={onFinish}
              layout="vertical"
            >
              <Form.Item
                label="Code trong thẻ <head>"
                name="customCodeInHeadTag"
              >
                <TextArea
                  autoSize={{ minRows: 3 }}
                  className="w-100"
                  placeholder="In the <head> tag"
                />
              </Form.Item>
              <Form.Item
                label="Bắt đầu của thẻ <body>"
                name="customCodeBeginBodyTag"
              >
                <TextArea
                  autoSize={{ minRows: 3 }}
                  className="w-100"
                  placeholder="Bắt đầu của thẻ <body>"
                />
              </Form.Item>
              <Form.Item
                label="Kết thúc của thẻ <body>"
                name="customCodeEndBodyTag"
              >
                <TextArea
                  autoSize={{ minRows: 3 }}
                  className="w-100"
                  placeholder="Kết thúc của thẻ <body>"
                />
              </Form.Item>
              <Form.Item
                label="robot.txt"
                name="robotTxt"
              >
                <TextArea
                  autoSize={{ minRows: 3 }}
                  className="w-100"
                  placeholder="robot.txt"
                />
              </Form.Item>
              <Form.Item
                label={`Public Google Captcha`}
                name="publicGoogleCaptcha"
              >
                <Input
                  className="w-100"
                  placeholder={`Public Google Captcha`}
                />
              </Form.Item>
              <Form.Item
                label={`Private Google Captcha`}
                name="privateGoogleCaptcha"
              >
                <Input
                  className="w-100"
                  placeholder={`Private Google Captcha`}
                />
              </Form.Item>
              <Form.Item
                label={`Google Auth ClientId`}
                name="googleAuthClientId"
              >
                <Input
                  className="w-100"
                  placeholder={`Google Auth ClientId`}
                />
              </Form.Item>
              <Form.Item
                label={`Google Auth Client Secret`}
                name="googleAuthClientSecret"
              >
                <Input
                  className="w-100"
                  placeholder={`Google Auth Client Secret`}
                />
              </Form.Item>
              <Form.Item
                label={`Google Auth RedirectUri`}
                name="googleAuthRedirectUrl"
              >
                <Input
                  className="w-100"
                  placeholder={`Google Auth RedirectUri`}
                />
              </Form.Item>

              <Form.Item
                label={`Facebook Auth ClientId`}
                name="facebookAuthClientId"
              >
                <Input
                  className="w-100"
                  placeholder={`Facebook Auth ClientId`}
                />
              </Form.Item>
              <Form.Item
                label={`Facebook Auth Client Secret`}
                name="facebookAuthClientSecret"
              >
                <Input
                  className="w-100"
                  placeholder={`Facebook Auth Client Secret`}
                />
              </Form.Item>
              <Form.Item
                label={`Facebook Auth RedirectUri`}
                name="facebookAuthRedirectUrl"
              >
                <Input
                  className="w-100"
                  placeholder={`Facebook Auth RedirectUri`}
                />
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default WebsiteConfig;
